const zh={
    nav: {
        home: "首页",
        role: "原型体资料",
        video: "影像展示",
        news: "新闻资讯"
    },
    role: {
        playerWarning: "你的浏览器不支持video标签,请换一个浏览器试试。",
        rg:{
            name: "拉格纳",
            intro: "嗜血之刃，亢奋连击。不断以生命值为代价释放猛烈的剑招，能从敌人的毁灭和痛苦里回复自身血量，在命悬一线之时拥有最强大的战力。"
        },
        a: {
            name: "Λ-No.11-",
            intro: "万千利刃，遵从召唤。擅长从虚空中召唤无数剑刃，对敌人进行远程多段连击，具有极大范围的战场控制和输出能力，能制造铺天盖地的视觉效果。"
        },
        hk:{
            name: "白面",
            intro: "大开大合，攻守兼备。拥有极高的攻击力和格挡防反能力。虽然有较慢的移动效率，但其迅猛的居合斩能瞬时加速斩杀敌人"
        },
        hb:{
            name: "琥珀响音",
            intro: "灵巧的刺客，以短刀和飞镖作为武器，擅长从背后发起进攻，以暴风骤雨般的快速攻击摧毁敌人。"
        },
        nol:{
            name: "诺艾儿",
            intro: "枪炮连携，华丽进攻。有着极其灵活的浮空作战和位移能力，擅长各种热武器的组合攻击，以灵动又迅猛的火力打击毁灭对手。"
        },
        kk:{
            name: "九重",
            intro: "火力倾泻,狂轰滥炸。通过火箭、激光等多种科技手段攻击敌人，可以在战斗场景中布下天罗地网，制造海量的范围伤害。"
        },
        ma:{
            name: "枣麻衣",
            intro: "飘逸炫目，枪出如风。能以长枪卷起旋风，拥有高频率、长距离的攻击特点，可以将手中的长枪掷出收回、突刺击退敌人、或全力挥舞进行大范围高速劈砍。"
        },
        es:{
            name: "Es",
            intro: "纹章巨剑，利刃舞步。手持巨剑，拥有以召唤纹章为核心的华丽剑招，兼具范围伤害和机动性，能在众多敌人中来去自如，将之尽数击败。"
        }
    },
    news: {
        more: "查看更多",
        slider: [
            {
                title: '冲击动作巅峰！超爽动作肉鸽Steam全球发售——《苍翼：混沌效应》',
                img: require("@/assets/images/news-slider1-zh.jpg"),
                content: '<p>《苍翼：混沌效应》已在Steam全球发售，售价68元，首周折扣12%，ACE世界正式连接！</p><p>《苍翼：混沌效应》是由经典格斗IP苍翼默示录官方授权、91Act开发的2D横板动作肉鸽游戏。基于格斗游戏演变而来的全新动作肉鸽，天花板品质的2D动作战斗体验，每个角色完全独立的动作设计，可深度定制组合的、千变万化的角色动作系统！</p><p>点击下方商店链接立即下载，体验极致畅快的2D动作战斗吧！</p><p>Steam商店页：<a href="https://store.steampowered.com/app/2273430">https://store.steampowered.com/app/2273430</a></p><p>官方Q群：928900991</p><p>BiliBili：<a href="https://space.bilibili.com/1663803541">https://space.bilibili.com/1663803541</a></p>'
            },
            {
                title:'《苍翼：混沌效应》首发常见问题解答',
                img: require("@/assets/images/news-slider2-zh.jpg"),
                content: '<p>Q：游戏什么时候发售，售价是多少？</br>A：将于8月16日10:00在Steam全球发售，国区定价68元人民币，首周折扣12%。</p><p>Q：游戏的发售版本有多少内容？</br>A：发售版本游戏的内容量如下：</br>·4组大型主题关卡+1个随机生成的类银河城地图</br>·7位风格迥异的角色和100+角色可选潜能</br>·8种元素体系和200+元素构建策略</br>·10名拥有独特机制的BOSS+50+种不同特色的敌人</br>·所有BOSS形态机制全面进化的进阶挑战模式</br>·成熟独特的剧情表演形式</br>我们希望给出足够丰富的、有诚意的内容，让大家既能体验到这款游戏的魅力，又能值回票价！</p><p>Q：发售后，未来的更新计划是？</br>A：我们计划于9月和11月分别免费更新两次DLC，追加新角色和新剧情。同时在2024年的Q1发布正式版，包括完整的多分支多结局剧情、更多的可操控角色、以及新的游玩模式。</p><p>Q：游戏支持的语言有哪些？</br>A：发售版本在所有地区均完全支持中文语音。同时支持简体中文、英语及日语文本。</p><p>Q：游戏支持的系统以及最低配置？</br>A：同时支持Windows和MacOS系统，为保证游玩流畅度，Windows最低配置建议在Intel Core i3/4 GB RAM/GTX 950及以上，MacOS最低配置建议在MacBook Pro 2018及以上。</p><p>Q：游戏运行推荐的分辨率是？</br>A：推荐在2560*1440（2K）分辨率下运行。</p><p>Q：游戏是否适配手柄和Steam Deck？</br>A：完全适配手柄，在游戏内设置可以自由切换键鼠或手柄，并可以自定义调整键位。游戏也可以在Steam Deck上流畅运行。</p><p>Q：游戏是否支持多人游玩？</br>A：发售版本仅支持单人游玩，暂时没有本地或在线联机内容。</p><p>Q：“迭代测试”获得的兑换码奖励可以在游戏中使用吗？</br>AA：兑换码可以在这次的PC版中使用，但需要在正式版上线后才能兑换，正式版计划于2024年Q1发布。</p><p>Q：如何找到官方资讯和交流平台？</br>你可以关注我们的Steam商店，同时我们也在各大社群建立了官方交流阵地，非常欢迎玩家们加入和我们交流。<br/>官方QQ群：928900991<br/>BiliBili：<a href="https://space.bilibili.com/1663803541">https://space.bilibili.com/1663803541</a> </p><p>Q：如何联系官方人员反馈建议？</br>A：你可以通过上述的社群渠道联络我们，如果你希望更高效实时地和官方人员沟通，强烈推荐加入官方QQ群/Discord。</p>'
            },
        ],
        url: [
            {
                title: "海外独立游戏展会上，这款国产新星让外媒惊艳",
                url: "https://www.tgbus.com/news/208015"
            },
            {
                title: "海外独立游戏展会上的国产新星，游戏出海究竟能有多少种可能",
                url: "https://www.gameweibo.com/article-619892.html",
            },
            {
                title: "《苍翼：混沌效应》抢先评测：更适合动作宝宝体质的肉鸽游戏",
                url: "https://www.3dmgame.com/score/3743068.html",
            },
            {
                title: "国产作品如何在海外独立游戏展上取得好成绩？",
                url: "http://www.chuapp.com/?c=Article&a=index&id=289428",
            }
        ]
    },
}
export default zh
